import { GxRadio } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/radiobutton.module.scss'

interface IProps {
  name: string
  children: any
  className?: string
}

const Radiobutton = ({
  name,
  children,
  className = '',
  ...props
}): React.ReactElement<IProps> => {
  return (
    <GxRadio
      name={name}
      className={classNames({
        [style.default]: true,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}
    </GxRadio>
  )
}

export default Radiobutton
